import { render } from "./HomeOurPeople.vue?vue&type=template&id=2328f94c&scoped=true&ts=true"
import script from "./HomeOurPeople.vue?vue&type=script&lang=ts"
export * from "./HomeOurPeople.vue?vue&type=script&lang=ts"

import "./HomeOurPeople.vue?vue&type=style&index=0&id=2328f94c&lang=scss&scoped=true"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2328f94c"]])

export default __exports__